import { Controller } from 'react-hook-form';

import { Radio } from './Radio';

/**
 * @typedef {string | number} RadioValue
 */

/**
 * @typedef {(focused: boolean, selected: boolean) => string} ClassNameFn
 */

/**
 * @typedef {(focused: boolean, selected: boolean) => React.CSSProperties} StyleFn
 */

/**
 * @typedef {({
 *    requiredProps: {
 *       role: string;
 *       tabIndex: number;
 *       onFocus: () => void;
 *       onClick: () => void;
 *     };
 *     selected: boolean;
 *     focused: boolean;
 * }) => React.ReactNode} RenderFn
 */

/**
 * @param props
 *
 * @param {import('react-hook-form').Control} props.control
 * @param {import('react-hook-form').UseControllerProps['name']} props.name
 * @param {import('react-hook-form').UseControllerProps['rules']} [props.rules]
 *
 * @param {RadioValue} props.value
 * @param {string} props.label
 * @param {string} [props.description]
 *
 * @param {string | ClassNameFn} [props.containerClassName]
 * @param {string | ClassNameFn} [props.className]
 * @param {React.CSSProperties | StyleFn} [props.style]
 * @param {RenderFn} [props.render]
 *
 *
 * @returns {JSX.Element}
 */
export function ControlledRadio({ control, name, rules, value, ...props }) {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <Radio
          name={field.name}
          value={value}
          selected={value === field.value}
          onSelect={field.onChange}
          {...props}
        />
      )}
    />
  );
}
